var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Close/Small",
    fill: "#181818",
    stroke: "#181818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CloseSmallIcon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29498705,-0.523194772 C7.21172816,-0.43993588 7.15970877,-0.325437486 7.1579611,-0.19873181 L6.95894016,14.2555391 C6.96197166,14.3681807 7.00964115,14.4693994 7.08472338,14.5424386 C7.16104025,14.6166788 7.26567881,14.6618051 7.38054999,14.6602207 C7.50725567,14.6584731 7.62175406,14.6064537 7.70501295,14.5231948 C7.78827184,14.4399359 7.84029123,14.3254375 7.8420389,14.1987318 L8.04105984,-0.255539064 C8.03802834,-0.36818074 7.99035885,-0.469399438 7.91527662,-0.542438612 C7.83895975,-0.616678831 7.73432119,-0.661805146 7.29498705,-0.523194772 Z",
    id: "Rectangle",
    transform: "translate(7.500000, 7.000000) rotate(-45.000000) translate(-7.500000, -7.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07660901,-0.534324238 C7.00236879,-0.458007369 6.95724247,-0.353368812 6.9588269,-0.238497627 L7.1579611,14.1987318 C7.15970877,14.3254375 7.21172816,14.4399359 7.29498705,14.5231948 C7.37824594,14.6064537 7.49274433,14.6584731 7.61945001,14.6602207 L7.63782136,14.6601732 C7.74579665,14.6586363 7.84915077,14.6106411 7.92339099,14.5343242 C7.99763121,14.4580074 8.04275753,14.3533688 8.0411731,14.2384976 L7.8420389,-0.19873181 C7.84029123,-0.325437486 7.78827184,-0.43993588 7.70501295,-0.523194772 C7.62009886,-0.608108864 7.50236767,-0.656815331 7.07660901,-0.534324238 Z",
    id: "Rectangle-Copy",
    transform: "translate(7.500000, 7.000000) rotate(45.000000) translate(-7.500000, -7.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmallIcon);
export default __webpack_public_path__ + "static/media/CloseSmallIcon.0e265a7f.svg";
export { ForwardRef as ReactComponent };